import {
  GetSourceFromSegmentProps,
  GetSourceFromSegmentResult,
  getUrlProps,
} from './';

export function getSourceFromSegment(
  props: GetSourceFromSegmentProps,
): GetSourceFromSegmentResult {
  const { url } = props;

  if (!url)
    return {
      urlDestination: 'void',
    };

  return {
    urlDestination: 'contentful',
    url: getUrlProps(url).path,
  };
}
